<script>
import OrdersApi from "@/services/orders-api";

export default {

    props: {

        customerId: Number,
        start:{
          type:String,
          default:null
        },
        end:{
          type:String,
          default:null
        },
    },

    
    data () {
        return {
        singleSupplierFields: [
        
        { key:"submissionDate", label: "Date",   sortable: false, tdClass:"font-weight-bold align-middle",},
        { key:"submissionUserName", label: "Utilisateur",   thClass:"", tdClass:" align-middle"},
        { key:"status", label: "Etat de livraison",   thClass:"text-right ", tdClass:"text-right align-middle"},
        { key:"export", label:"",tdClass:"text-right align-middle"},
        { key:"actions", label:"",tdClass:"text-center align-middle"},
        ],

        forSupplierFields: [
        
        { key:"submissionDate", label: "Date", sortable: false, tdClass:"font-weight-bold align-middle"},
        { key:"ref", label: "Ref",thClass:"",tdClass:" align-middle" },
        { key:"submissionUserName", label: "Utilisateur",   thClass:" ", tdClass:" align-middle"},
        { key:"customerName", label: "Client", tdClass:"font-weight-bold align-middle"},        
        { key:"status", label: "Etat de livraison",  thClass:"text-right ", tdClass:"text-right  align-middle"},
        { key:"restartSync", label:"",tdClass:"text-right align-middle"},
        { key:"export", label:"",tdClass:"text-right align-middle"},
        { key:"actions", label:"",tdClass:"text-center align-middle"},
        ],

        pagemodel: {currentPage : 1, perPage : 3, totalRows: 0},
        pendingValidationOrdersList: [],
        isTableLoading: false,
        exportOrdersInProgress : false,

        }

    },
    mounted () {
      this.getPartnerOrders();
    },

    computed: {
        role() {
          return this.$cookies.get('userr');
        },
    },

methods: {
    
    exportEXCEL(orderId){
        this.exportOrdersInProgress = true;
      OrdersApi.exportOrder(orderId)
       .then(() => {
           this.exportOrdersInProgress = false;
        })
    },

    getPartnerOrders() {
      this.isTableLoading = true

      if (this.role==1) {
         OrdersApi.getOrders(this.pagemodel.currentPage, this.pagemodel.perPage, true,null,this.customerId,this.start,this.end,false,null, null, true)
      .then(orders => {
        if(orders){
          this.pendingValidationOrdersList = orders.list
          this.pagemodel.totalRows = orders.total;
          this.pagemodel.currentPage = orders.page;
          this.pagemodel.perPage = orders.pageSize;
          this.pagemodel.pageSize = orders.pageSize;
        }

      })
      .finally(() => {
        this.isTableLoading=false 
      })
      }

      if(this.role==0){

      OrdersApi.getOrdersByCustomer(this.pagemodel.currentPage, this.pagemodel.perPage,null, true,null,false,this.start,this.end, null, null, true)
      .then(orders => {
        if(orders){
          this.pendingValidationOrdersList = orders.list
          this.pagemodel.totalRows = orders.total;
          this.pagemodel.currentPage = orders.page;
          this.pagemodel.perPage = orders.pageSize;
          this.pagemodel.pageSize = orders.pageSize;

        }

      })

      .finally(() => {
        this.isTableLoading=false 
      })

      }
    },
},

  watch: {

    supplierId : function(){
      this.getPartnerOrders()
    },

    customerId: function(){
      this.getPartnerOrders()
    },

    end: function(){
      if((this.end  && this.start) || (!this.end  && !this.start) ){
        this.getPartnerOrders()
      }
      
    },
    start: function(){
      if((this.end && this.start) || (!this.end  && !this.start)  ){
        this.getPartnerOrders()

      }
    },
  },
  };


</script>


<template>
<div>
    <div class="table-responsive mt-3" style="min-height: 20em">        
        <b-table 
        :busy="isTableLoading"
        :striped="true"

        :small="false"
        :hover="true"

        :items="pendingValidationOrdersList"
        :fields="role==1 ? forSupplierFields : singleSupplierFields"

        :perPage="pagemodel.perPage"
        class="table  "
        >
      <template v-slot:table-busy>
        <div class="text-center my-2">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </template>

      <template v-slot:head(submissionDate)>
        {{ $t("ordersMenu.list.header.submissionDate") }} 
      </template>

      <template v-slot:head(ref)>
        {{ $t("ordersMenu.list.header.ref") }} 
      </template>

      <template v-slot:head(itemsCount)>
        {{ $t("ordersMenu.list.header.itemsCount") }} 
      </template>

      <template v-slot:head(total)>
        {{ $t("ordersMenu.list.header.total") }} 
      </template>

      <template v-slot:head(totalWithTaxes)>
        {{ $t("ordersMenu.list.header.totalWithTaxes") }} 
      </template>

      <template v-slot:head(customerName)>
        {{ $t("ordersMenu.list.header.customerName") }} 
      </template>

      <template v-slot:head(status)>
        {{ $t("ordersMenu.list.header.orderStatus") }} 
      </template>

      <template v-slot:head(submissionUserName)>
        Utilisateur
      </template>

      <template v-slot:head(sageRef)>
        {{ $t("ordersMenu.list.header.sageRef") }} 
      </template>

      <template v-slot:cell(actions)="{item}"> 
        <router-link :to="{ path: '/orders/order', query: { orderId: item.id }}">
          <b-button title="Ouvrir"  size="sm"   variant="outline-secondary" >
                <i class="far fa-file-alt  font-size-16 align-middle mr-0 mr-xl-2"></i>
                <span class="d-none font-weight-bold d-xl-inline">{{ $t("ordersMenu.list.button")}}</span>
          </b-button> 
        </router-link>

      </template>

      <template v-slot:cell(export)="{item}">
          <b-button title="Exporter"  size="sm"   variant="outline-info"  @click.prevent="exportEXCEL(item.id)" :disabled="exportOrdersInProgress"  >
            <b-spinner small :class="exportOrdersInProgress ? 'mr-1' : 'd-none'"></b-spinner>
            <i class="fas fa-file-excel  font-size-16  font-weight-bold align-middle mr-0 mr-xl-2"></i>
            <span class=" font-weight-bold text-uppercase d-none d-xl-inline">{{ $t("ordersMenu.list.export")}} </span>         
          </b-button> 
      </template> 

      <template v-slot:cell(status)="{value}">
        <h5 class="m-0" v-if="value == 0"><b-badge href="#" class="font-weight-bold" variant="danger">{{$t("ordersMenu.statusLabel.pendingValidation")}}</b-badge></h5>
      </template>

      <template v-slot:cell(submissionUserName)="{value}">
        {{value}}
      </template>

        <template v-slot:cell(ref)="{item,value}">
        <span :class="item.status ==0 ? 'text-danger' : ''">{{value}}</span>
        </template>

        <template v-slot:cell(submissionDate)="{item,value}">
          <span v-if="item.status == 0" class="text-danger"><i class="mdi mdi-clock-outline mr-2"></i> {{ item.creationDate }}</span>
          <span v-if="item.submissionDate">{{value}}</span>
        </template>

        <template v-slot:cell(sageRef)="{item}">
            {{item.sageRef}}
        </template>

        </b-table>
        <span v-if="!isTableLoading && pendingValidationOrdersList && !pendingValidationOrdersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('ordersMenu.list.empty')}} </span>
    </div>

    <!-- Pagination -->
    <div class="row pt-3 mb-sm-0">
        <div class="col-sm-8">
            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select @input="getPartnerOrders()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[3,5,10,15]"></b-form-select>
                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getPartnerOrders()" :disabled="isTableLoading" ></b-pagination>
                </ul>
            </div>
        </div>
    </div> 
    <!-- Fin Pagination  -->
</div>
</template>                 
               